import { Checkbox } from 'antd';
import styled from 'styled-components';
import type { CheckboxProps } from 'antd/es/checkbox';

export const StyledCheckbox = styled(Checkbox)<CheckboxProps>`
    .ant-checkbox-label {
        font-weight: 400;
        font-size: 16px;
    }
    .ant-checkbox-inner {
        width: 24px;
        height: 24px;
        border-radius: 8px;
        border: 2px solid ${(props) => props.theme.semantic.border};
        background-color: ${(props) => props.theme.semantic.surface};
        transition: all 0.3s ease;
    }
    .ant-checkbox-disabled .ant-checkbox-inner {
        border: 2px solid ${(props) => props.theme.semantic.border};
    }

    .ant-checkbox-checked .ant-checkbox-inner::after {
        position: absolute;
        display: table;
        border: solid white;
        border-width: 0 2px 2px 0;
        content: '';
        top: 40%;
        left: 50%;
        width: 6px;
        height: 12px;
        transform: translate(-50%, -50%) rotate(45deg);
    }

    .ant-checkbox-checked + .ant-checkbox-label,
    .ant-checkbox-label:hover {
        transition: all 0.3s ease;
        color: ${(props) => props.theme.semantic.primary};
    }

    .ant-checkbox:hover + .ant-checkbox-label {
        color: ${(props) => props.theme.semantic.primary};
    }

    .ant-checkbox-checked .ant-checkbox-inner {
        background-color: ${(props) => props.theme.semantic.primary};
        border: 2px solid ${(props) => props.theme.semantic.border};
    }
`;
